function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import PropTypes from 'prop-types';
import VirtualizedList from '@adsk/alloy-react-virtualized-list';
import { defaultSelectBoxRenderer } from '../layout/defaultRenderers';
import SelectBox from '../SelectBox';
/**
 * VirtualizedSelectBox, extends [SelectBox](selectbox) to add virtualized support
 */

var VirtualizedSelectBox = /*#__PURE__*/function (_React$Component) {
  _inherits(VirtualizedSelectBox, _React$Component);

  var _super = _createSuper(VirtualizedSelectBox);

  function VirtualizedSelectBox(props) {
    var _this;

    _classCallCheck(this, VirtualizedSelectBox);

    _this = _super.call(this, props);
    _this.state = {
      menuHeight: props.maxMenuHeight
    };
    _this.menuRenderer = _this.menuRenderer.bind(_assertThisInitialized(_this));
    _this.maybeUpdateMenuHeight = _this.maybeUpdateMenuHeight.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(VirtualizedSelectBox, [{
    key: "handleUpdateMenuHeight",
    value: function handleUpdateMenuHeight(menuHeight) {
      this.setState({
        menuHeight: menuHeight
      });
    }
  }, {
    key: "renderList",
    value: function renderList(_ref) {
      var items = _ref.items,
          renderItem = _ref.renderItem;
      return /*#__PURE__*/React.createElement(VirtualizedList, {
        items: items,
        renderItem: renderItem,
        overscanCount: this.props.overscanCount,
        onRowsRendered: this.maybeUpdateMenuHeight
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleUpdateMenuHeight(this.props.maxMenuHeight);
    }
  }, {
    key: "maybeUpdateMenuHeight",
    value: function maybeUpdateMenuHeight(_ref2) {
      var cellMesureCacheRef = _ref2.cellMesureCacheRef,
          items = _ref2.items;
      var height = items.reduce(function (preHeight, _item, index) {
        return preHeight + cellMesureCacheRef.current.rowHeight({
          index: index
        });
      }, 0);
      var menuHeight = Math.min(height, this.props.maxMenuHeight);

      if (menuHeight !== this.state.menuHeight) {
        this.handleUpdateMenuHeight(menuHeight);
      }
    }
  }, {
    key: "menuRenderer",
    value: function menuRenderer(_ref3) {
      var items = _ref3.items,
          renderItem = _ref3.renderItem;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: this.state.menuHeight
        }
      }, this.renderList({
        items: items,
        renderItem: renderItem
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children(_objectSpread(_objectSpread({}, this.props), {}, {
        menuRenderer: this.menuRenderer
      }));
    }
  }]);

  return VirtualizedSelectBox;
}(React.Component);

VirtualizedSelectBox.defaultProps = _objectSpread(_objectSpread({}, SelectBox.defaultProps), {}, {
  children: defaultSelectBoxRenderer,
  overscanCount: 5,
  maxMenuHeight: 300
});
VirtualizedSelectBox.propTypes = _objectSpread(_objectSpread({}, SelectBox.propTypes), {}, {
  /**
   * render function
   */
  children: PropTypes.func.isRequired,

  /**
   * overscan count
   */
  overscanCount: PropTypes.number,

  /**
   * The max height of the menu
   */
  maxMenuHeight: PropTypes.number
});
export default VirtualizedSelectBox;
//# sourceMappingURL=VirtualizedSelectBox.js.map